"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebSocketKeepAliveService = void 0;
const Sentry = __importStar(require("@sentry/browser"));
class WebSocketKeepAliveService {
    constructor($rootScope, $interval, webSocketKeepAliveBrokerService) {
        this.$rootScope = $rootScope;
        this.$interval = $interval;
        this.webSocketKeepAliveBrokerService = webSocketKeepAliveBrokerService;
    }
    static factory($rootScope, $interval, webSocketKeepAliveBrokerService) {
        return new WebSocketKeepAliveService($rootScope, $interval, webSocketKeepAliveBrokerService);
    }
    start(agentId, agentFirstName, agentLastName) {
        if (this.$rootScope.webSocketKeepAliveInterval) {
            this.stop();
        }
        const socket = this.$rootScope.socket;
        const intervalMs = 15 * 1000;
        const ackTimeoutMs = WebSocketKeepAliveService.MAX_MISSED_ACK_TICKS * intervalMs;
        if (!socket) {
            return;
        }
        this.$rootScope.webSocketKeepAliveInterval = this.$interval(() => {
            if (this.$rootScope.socket !== socket || socket.readyState !== WebSocket.OPEN) {
                return;
            }
            const ackAge = Date.now() - this.webSocketKeepAliveBrokerService.getLastAckAt(socket);
            const awaitingAck = this.webSocketKeepAliveBrokerService.isAwaitingAck(socket);
            if (awaitingAck && ackAge >= intervalMs && !this.webSocketKeepAliveBrokerService.isBlocked(socket)) {
                this.webSocketKeepAliveBrokerService.block(socket);
                Sentry.captureMessage('Event: Socket keep-alive ACK hasn\'t been received. | Agent Id: ' + agentId + " | Agent Name: " + agentFirstName + " " + agentLastName + " | Date: " + new Date().toLocaleString('en-US', {
                    timeZone: 'UTC',
                    hour12: false
                }), {
                    level: "log",
                    fingerprint: ["agent-status-keep-alive-missed"],
                    extra: {
                        ackAge: ackAge,
                        socketUrl: socket.url,
                    },
                });
            }
            if (awaitingAck && ackAge >= ackTimeoutMs) {
                // Watchdog: the connection is a zombie. Without this close the
                // agent keeps looking online locally (readyState stays OPEN and
                // sends buffer silently) while the backend has already dropped
                // them. Force-close so the dashboard's onclose handler runs the
                // reconnect flow and re-announces the status on a fresh socket.
                console.error('[AgentStatusWS] Keep-alive watchdog force-closing zombie socket. ackAge:', ackAge);
                this.webSocketKeepAliveBrokerService.markWatchdogInitiated(socket);
                Sentry.captureMessage('Event: Keep-alive watchdog force-closed zombie socket | Agent Id: ' + agentId + " | Agent Name: " + agentFirstName + " " + agentLastName + " | Date: " + new Date().toLocaleString('en-US', {
                    timeZone: 'UTC',
                    hour12: false
                }), {
                    level: "log",
                    fingerprint: ["keep-alive-watchdog-close"],
                    extra: {
                        ackAge: ackAge,
                        socketUrl: socket.url,
                        watchdogInitiated: true,
                    },
                });
                try {
                    socket.close(WebSocketKeepAliveService.WATCHDOG_CLOSE_CODE, 'keep-alive-timeout');
                }
                catch (e) {
                    console.error('[AgentStatusWS] Keep-alive watchdog failed to close socket', e);
                }
                return; // don't send on the socket we just closed
            }
            this.webSocketKeepAliveBrokerService.markAwaitingAck(socket);
            try {
                socket.send(JSON.stringify({
                    agentId: agentId,
                    reason: 'keep-alive'
                }));
            }
            catch (error) {
                console.error('[AgentStatusWS] Keep-alive send failed', error);
                this.webSocketKeepAliveBrokerService.markWatchdogInitiated(socket);
                try {
                    socket.close(WebSocketKeepAliveService.WATCHDOG_CLOSE_CODE, 'keep-alive-send-failed');
                }
                catch (_) { }
            }
        }, intervalMs);
    }
    stop() {
        // Called defensively from multiple sites (onerror, onclose, and before
        // opening a replacement socket in WebSocketService.connect()), so a
        // no-op call is expected and not an error condition.
        if (!this.$rootScope.webSocketKeepAliveInterval) {
            return;
        }
        this.$interval.cancel(this.$rootScope.webSocketKeepAliveInterval);
        this.$rootScope.webSocketKeepAliveInterval = undefined;
    }
}
exports.WebSocketKeepAliveService = WebSocketKeepAliveService;
/**
 * Consecutive interval ticks without a keep-alive ACK before the socket is
 * considered a zombie (half-open TCP: browser still reports OPEN, but
 * nothing comes back) and gets force-closed. 2 ticks ~= 30s of silence.
 */
WebSocketKeepAliveService.MAX_MISSED_ACK_TICKS = 2;
/**
 * App-specific close code sent by the watchdog. Distinguishable in logs and
 * treated as an abnormal closure by the dashboard close handler, which
 * triggers the auto-reconnect + status re-announce flow.
 */
WebSocketKeepAliveService.WATCHDOG_CLOSE_CODE = 4000;
angular.module('callX').service('WebSocketKeepAliveService', ['$rootScope', '$interval', 'WebSocketKeepAliveBrokerService', WebSocketKeepAliveService.factory]);
